import {
  VIDEO_EDITOR_TIMELINE_SCALE,
  VIDEO_EDITOR_TRACK_TYPE,
} from "./constants";

const TRACK_ADD_ACTION_ID_PREFIX = "video-editor-track-add";
const TRACK_ADD_GAP_PX = 6;

const TRACK_ADD_WIDTH = {
  [VIDEO_EDITOR_TRACK_TYPE.IMAGE]: {
    empty: 150,
    compact: 24,
  },
  [VIDEO_EDITOR_TRACK_TYPE.VIDEO]: {
    empty: 190,
    compact: 32,
  },
  [VIDEO_EDITOR_TRACK_TYPE.AUDIO]: {
    empty: 138,
    compact: 24,
  },
};

const ADD_SUBTITLES_WIDTH_PX = 168;

const pixelsToTimelineDuration = ({ pixels, scaleWidth }) =>
  (pixels / Math.max(scaleWidth, 1)) * VIDEO_EDITOR_TIMELINE_SCALE;

const getTargetRow = ({ rows, type }) => {
  const typeRows = rows.filter((row) => row.type === type);
  if (
    type === VIDEO_EDITOR_TRACK_TYPE.IMAGE ||
    type === VIDEO_EDITOR_TRACK_TYPE.VIDEO
  ) {
    return typeRows[typeRows.length - 1] || null;
  }
  return typeRows[0] || null;
};

export const appendTrackAddActionsToRows = ({
  rows,
  scaleWidth,
  showAddSubtitles = false,
}) => {
  const nextRows = rows.map((row) => ({
    ...row,
    actions: [...(row.actions || [])],
  }));

  Object.entries(TRACK_ADD_WIDTH).forEach(([type, widths]) => {
    const targetRow = getTargetRow({ rows: nextRows, type });
    if (!targetRow) {
      return;
    }

    const typeRows = nextRows.filter((row) => row.type === type);
    const clips = typeRows.flatMap((row) => row.actions || []);
    const hasClips = clips.length > 0;
    const lastClipEnd = clips.reduce(
      (maxEnd, action) => Math.max(maxEnd, Number(action.end) || 0),
      0
    );
    const widthPx = hasClips ? widths.compact : widths.empty;
    const start =
      lastClipEnd +
      (hasClips
        ? pixelsToTimelineDuration({
            pixels: TRACK_ADD_GAP_PX,
            scaleWidth,
          })
        : 0);
    const end =
      start +
      pixelsToTimelineDuration({
        pixels: widthPx,
        scaleWidth,
      });

    targetRow.actions.push({
      id: `${TRACK_ADD_ACTION_ID_PREFIX}-${type}`,
      start,
      end,
      effectId: type,
      flexible: false,
      movable: false,
      minStart: 0,
      data: {
        isTrackAdd: true,
        type,
        hasClips,
      },
    });
  });

  if (showAddSubtitles) {
    const imageRow = getTargetRow({
      rows: nextRows,
      type: VIDEO_EDITOR_TRACK_TYPE.IMAGE,
    });
    const targetRow =
      imageRow ||
      getTargetRow({
        rows: nextRows,
        type: VIDEO_EDITOR_TRACK_TYPE.VIDEO,
      });
    if (targetRow) {
      const addActions = (targetRow.actions || []).filter(
        (action) => action.data?.isTrackAdd
      );
      const lastAdd = addActions[addActions.length - 1];
      const start =
        (Number(lastAdd?.end) || 0) +
        pixelsToTimelineDuration({
          pixels: TRACK_ADD_GAP_PX,
          scaleWidth,
        });
      const end =
        start +
        pixelsToTimelineDuration({
          pixels: ADD_SUBTITLES_WIDTH_PX,
          scaleWidth,
        });

      targetRow.actions.push({
        id: `${TRACK_ADD_ACTION_ID_PREFIX}-subtitle`,
        start,
        end,
        effectId: VIDEO_EDITOR_TRACK_TYPE.SUBTITLE,
        flexible: false,
        movable: false,
        minStart: 0,
        data: {
          isTrackAdd: true,
          type: VIDEO_EDITOR_TRACK_TYPE.SUBTITLE,
          hasClips: false,
        },
      });
    }
  }

  return nextRows;
};
